module.exports = __webpack_public_path__ + "img/003-value.47a68417.svg";